import axios from '@/api/config';

const liveInfo = {
  getLiveInfoById(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getLiveInfo/` + data, {});
  },
  getLiveInfoDetail(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getLiveInfoDetail`, {params: data});
  },
  getLiveInfo(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getLiveInfo`, {params: data});
  },
  getLiveInfoList(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getLiveInfoList`, {params: data});
  },
  getLiveInfoTree(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getLiveInfoTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/liveInfo/pageList`, data);
  },
  getCourseList(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getCourseList`, {params: data});
  },
  liveLogPageList(data) {
    return axios.post(`${process.env.BASE_URL}/liveLog/pageList`, data);
  },
  addLiveInfo(data) {
    return axios.post(`${process.env.BASE_URL}/liveInfo/addLiveInfo`, data);
  },
  batchAddLiveInfo(data) {
    return axios.post(`${process.env.BASE_URL}/liveInfo/batchAddLiveInfo`, data);
  },
  updateLiveInfo(data) {
    return axios.put(`${process.env.BASE_URL}/liveInfo/updateLiveInfo`, data);
  },
  deleteLiveInfo(data) {
    return axios.delete(`${process.env.BASE_URL}/liveInfo/deleteLiveInfo`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/exportExcel`, {params: data});
  },
  getZshdRoom(data) {
    return axios.get(`${process.env.BASE_URL}/liveInfo/getZshdRoom`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.POI_URL}/liveInfo/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/liveInfo/active`, data);
  },
}

export default liveInfo;



// WEBPACK FOOTER //
// ./src/api/liveInfo.js